!function () {
  const state = {};
  const selectors = {
    section: '.extended-announcement-bar',
    sectionWrapper: '.extended-announcement-bar__wrapper',
    headerGroup: '.shopify-section-group-header-group',
    slider: '.extended-announcement-bar__slider'
  };
  const bodyClasses = {
    addonEnabled: 'extended-announcement-bar-enabled',
    stickyBar: 'extended-announcement-bar-sticky'
  };

  const section = document.querySelector(selectors.section);
  const headerGroup = document.querySelector(selectors.headerGroup);

  function ExtendedAnnouncementBar(el) {
    this.sectionSettings = theme.helpers.safelyParseJson(el.dataset.sectionSettings);

    if (!this.sectionSettings) return;

    state.enableStickyBar = this.sectionSettings.enableStickyBar;
    state.rotationSpeed = this.sectionSettings.rotationSpeed;
    this.slider = el.querySelector(selectors.slider);

    if (!this.slider) return;

    const options = {
      arrows: false,
      dots: false,
      autoplay: true,
      autoplaySpeed: state.rotationSpeed,
      fade: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: window.themeVariables.animation.speed
    };

    theme.helpers.loadComponent('slider', () => {
      theme.Slider.init({ slider: this.slider, options: options });
    });
  }

  if (!section || !headerGroup) return;

  window.theme = window.theme || {};
  window.theme.sections = window.theme.sections || new theme.Sections();

  ExtendedAnnouncementBar.prototype = Object.assign({}, ExtendedAnnouncementBar.prototype, {
    onUnload: function () {
      theme.Slider.destroy(this.slider);
    },
    onBlockSelect: function (evt) {
      const slickIndex = this.slider
        .querySelector(`[data-block-id="${evt.detail.blockId}"]:not(.slick-cloned)`)
        ?.dataset.slickIndex;

      if (slickIndex) {
        $(this.slider).slick('slickGoTo', slickIndex).slick('slickPause');
      }
    },
    onBlockDeselect: function () {
      if (this.slider.classList.contains('slick-initialized')) {
        $(this.slider).slick('slickPlay');
      }
    }
  });

  theme.ExtendedAnnouncementBar = ExtendedAnnouncementBar;
  theme.sections.register('extended-announcement-bar', theme.ExtendedAnnouncementBar);

  headerGroup.insertAdjacentElement('beforebegin', section);

  if (document.body.classList.contains('font-icons-loaded')) {
    document.body.classList.add(bodyClasses.addonEnabled);
  } else {
    document.addEventListener('theme:font-icons:loaded', () => {
      document.body.classList.add(bodyClasses.addonEnabled);
    });
  }

  if (state.enableStickyBar) {
    document.body.classList.add(bodyClasses.stickyBar);
  }
}();
